module.exports = __webpack_public_path__ + "static/background-bottom-8e5797be676978dd3e091bd0b003ce8b.svg";